import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

export function PopoverActions(props: PropsWithChildren) {
  return <div className={styles.popoverActions}>{props.children}</div>;
}

const styles = {
  popoverActions: css({
    display: "flex",
    flexDirection: "row",
    gap: "var(--space-2)",
    paddingBottom: "var(--space-4)",
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
    paddingTop: "var(--space-1)",
  }),
};
